export interface SitterBranchWorker {
  id?: number;
  workerId?: string;
  sitterId?: number;
  statusId?: number;
  accountType?: number;
}

export enum BranchWorkerStatusIds {
  PENDING = 1,
  ACTIVE = 2,
  DEACTIVATED = 3,
}

export enum BranchWorkerStatuses {
  PENDING = 'Pending',
  ACTIVE = 'Active',
  DEACTIVATED = 'Deactivated',
}

export enum BranchWorkerAccountTypeIds {
  NONE = 1,
  WALLET = 2,
  CARD = 3
}

export enum BranchWorkerAccountTypes {
  NONE = 'None',
  WALLET = 'Wallet',
  CARD = 'Card'
}
